import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { BillingDiscrepancyRequestReasonDropdownComponent } from '../../components/DomainData/BillingDiscrepancyRequestReasonDropdown.component';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';

@Component({
    selector: 'my-billing-discrepancy-details',
    templateUrl: './BillingDiscrepancyDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => BillingDiscrepancyDetailsComponent) }]
})
export class BillingDiscrepancyDetailsComponent extends BaseControlGroupComponent {

    public form: FormGroup;
    billingDiscrepancyInfo: ent.BillingDiscrepancyInfo = new ent.BillingDiscrepancyInfo();

    @Input() public showRequestType: boolean;
    @Input() public showRequestReason: boolean;
    @Input() public showBillingAction: boolean;

    @Input() public requireRequestType: boolean;
    @Input() public requireRequestReason: boolean;
    @Input() public requireBillingAction: boolean;

    @Output() public requestTypeChanged: EventEmitter<number> = new EventEmitter();

    @ViewChild(BillingDiscrepancyRequestReasonDropdownComponent) public billingDiscrepancyRequestReasonDropdownComponent: BillingDiscrepancyRequestReasonDropdownComponent;




    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.billingDiscrepancyInfo = request.BillingDiscrepancyInfo;


    }

    constructor(fb: FormBuilder) {
        super();
        let group = {
            'requestType': '',
            'requestReason': '',
            'billingAction': '',

        };

        this.form = fb.group(group);

    }


    ngOnInit(): void {
        if (this.requireRequestType) {
            this.form.controls['requestType'].setValidators([dropDownValidator, Validators.required]);
        }

        if (this.requireRequestReason) {
            this.form.controls['requestReason'].setValidators([dropDownValidator, Validators.required]);
        }

        if (this.requireBillingAction) {
            this.form.controls['billingAction'].setValidators([dropDownValidator, Validators.required]);
        }

    }

    requestTypeChange(event: any) {
        this.billingDiscrepancyInfo.BillingDiscrepancyRequestTypeID = event;

        this.billingDiscrepancyRequestReasonDropdownComponent.loadOnDemand(event);

        this.requestTypeChanged.emit(event);
    }

    requestReasonChange(event: any) {
        this.billingDiscrepancyInfo.BillingDiscrepancyRequestReasonID = event;
    }

    billingActionChange(event: any) {
        this.billingDiscrepancyInfo.BillingActionID = event;
    }



}